import { detect } from "detect-browser";
const IS_DEV = process.env.NODE_ENV !== "production";
export interface BrowserInfo {
    name: string;
    os: string;
    version: string;
}

export function getBrowser(): BrowserInfo {
    const toRet = detect();
    if (toRet === null)
        return {
            name: "unknown",
            os: "unknown",
            version: "-1"
        };
    return {
        name: toRet.name.toLocaleLowerCase(),
        os: toRet.os ?? "unknown",
        version: toRet.version ?? "unknown"
    };
}

export function redirect(target: string) {
    if (!target)
        return;
    try {
        if (IS_DEV && (window.location.search.includes("authdebug=1") || window.location.hash.includes("authdebug=1") || localStorage.getItem("authRoutingDebug") === "1")) {
            console.log("[auth-routing] BrowserHelper.redirect", {
                from: window.location.href,
                target,
            });
        }
    } catch {
        // ignore debug logging errors
    }
    window.location.assign(target);
}